import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./Navtabs.css";
import "./NavtabsResponsive.css";
import CustomAnchor from "../../shared/Anchor/CustomAnchor";
import { useEffect, useState } from "react";
import { useAppContext } from "../../App";

function Navtabs() {
  const context = useAppContext()
  const [expandAboutMenu, setExpandAboutMenu] = useState(false);

  useEffect(() => {
    setExpandAboutMenu(!context?.innerWidth)
  }, [context])

  useEffect(() => {
    document.addEventListener("click", (e: any) => {
      if (
        !new Array(...e.target?.classList).includes("expand-about-us-dropdown")
      ) {
        setExpandAboutMenu(false);
      }
    });

    return () => document.removeEventListener("click", () => {});
  }, []);

  return (
    <ul className="navbar-navtabs">
      <li>
        <CustomAnchor path="/" classname="navitem">
          <span>Home</span>
        </CustomAnchor>
      </li>
      <li>
        <CustomAnchor path="/shop" classname="navitem">
          <span>Shop</span>
        </CustomAnchor>
      </li>
      <li>
        <button
          className={`expand-about-us-dropdown btn btn-link navitem aboutus ${
            expandAboutMenu ? "show" : "hide"
          }`}
          onClick={() => setExpandAboutMenu(!expandAboutMenu)}
        >
          <span>About</span>
          <FontAwesomeIcon icon={faAngleDown} className="about-us-caret" />
        </button>
        <ul className={`about-sub-tabs ${expandAboutMenu ? "show" : "hide"}`}>
          <li>
            <CustomAnchor path="/about/company" classname="navitem">
              <span>Company</span>
            </CustomAnchor>
          </li>
          <li>
            <CustomAnchor path="/about/products-services" classname="navitem">
              <span>Products & Services</span>
            </CustomAnchor>
          </li>
          <li>
            <CustomAnchor path="/about/community" classname="navitem">
              <span>Community Programs</span>
            </CustomAnchor>
          </li>
          <li>
            <CustomAnchor path="/about/gallery" classname="navitem">
              <span>Gallery</span>
            </CustomAnchor>
          </li>
        </ul>
      </li>
      <li>
        <CustomAnchor path="/contact" classname="navitem">
          <span>Contact Us</span>
        </CustomAnchor>
      </li>
    </ul>
  );
}

export default Navtabs;
